import './user-avatar.scss';
import { ClbAvatar } from '@celebration/react/ClbAvatar/ClbAvatar';
import Text from '../text';

function UserAvatar({
    userName,
    userImageUrl = undefined,
}: Readonly<{
    userName: string;
    userImageUrl?: string;
}>) {
    return (
        <div className="user-avatar">
            <ClbAvatar
                size="sm"
                label={userName}
                url={userImageUrl}
                data-testid="user-avatar-image"
            />
            <Text value={userName} />
        </div>
    );
}

export default UserAvatar;
